<template>
  <div>
    <vxe-card>
      <template #header>
        <vxe-input v-model="containerNo" placeholder="business.label.containerNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-tip :content="caseNumber" :title="$t('business.label.caseOutBound')" status="error"/>
        <vxe-tip :content="changeBoxNumber" :title="$t('business.label.seedingReplenishmentExchangeBox')" status="error"/>
        <vxe-tip :content="tailBoxExchangeBoxNumber" :title="$t('business.label.tailBoxExchangeBox')" status="error"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="taskType" title="business.label.taskType"/>
        <vxe-column field="container.no" title="business.label.sourceContainer"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="customer.no" title="business.label.customerNo"/>
        <vxe-column field="customer.name" title="business.label.customerName"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.exchangeBox" icon="vxe-icon-association-form" status="primary" @click.stop="exchange(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'

export default {
  name: 'exchangeBoxList',
  data() {
    return {
      loading: false,
      data: [],
      containerNo: undefined,
      caseNumber: undefined,
      changeBoxNumber: undefined,
      tailBoxExchangeBoxNumber: undefined,
      numberDisabled: true
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    fetch() {
      this.loading = true
      findAll('exchangeListFactory', { 'container.no': this.containerNo }).then(res => {
        if (res.success) {
          let arr1 = []
          let arr2 = []
          let arr3 = []
          res.result.forEach(item => {
            if (item.taskType === '分播换箱' || item.taskType === '补货换箱') {
              arr1.push(item)
            } else if (item.taskType === '尾箱换箱') {
              arr2.push(item)
            } else if (item.taskType === '整箱出库') {
              arr3.push(item)
            }
          })
          this.changeBoxNumber = arr1.length
          this.tailBoxExchangeBoxNumber = arr2.length
          this.caseNumber = arr3.length
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    exchange(row) {
      this.$emit('exchange', { containerNo: row.container.no })
    }
  }
}
</script>
